import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentActionComponent } from './payment-action/payment-action.component';
import { PaymentErrorComponent } from './payment-error/payment-error.component';
import { PaymentLayoutComponent } from './payment-layout/payment-layout.component';
import { CommissionResolver, PaymentGuard } from './service';
import { CommissionAttachmentResolver } from './service/commission-attachment.resolver';

const routes: Routes = [
  {
    path: 'payment',
    component: PaymentLayoutComponent,
    children: [
      {
        path: '',
        component: PaymentActionComponent,
        canActivate: [PaymentGuard],
        resolve: {
          commissionData: CommissionResolver,
          attachmentData: CommissionAttachmentResolver }
      },
      {
        path: 'error',
        component: PaymentErrorComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentRoutingModule { }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-routing.module.ts